import { memo, ReactNode } from 'react';
import { Box, Paper, Skeleton, SxProps, Typography } from '@mui/material';
import { ChildrenProps, ConditionContainer, FlexBox } from '@dfl/mui-react-common';
import { FilterList } from '@dfl/mui-admin-layout';

type BoardHeaderProps = {
  title?: string | JSX.Element;
  badge?: ReactNode;
  subtitle?: string | ReactNode;
  mb?: number | string;
  isLoading?: boolean;
  hasFilter?: boolean;
  sx?: SxProps;
} & ChildrenProps;

const SubtitleEval = ({ subtitle }: { subtitle: string | ReactNode | undefined }) => {
  if (!subtitle) {
    return <></>;
  }
  return <>{subtitle}</>;
};
const PageHeader = ({ title, badge, isLoading, subtitle, children, hasFilter, mb, sx }: BoardHeaderProps) => {
  return (
    <Paper sx={{ padding: 2, mb: mb ?? 2, ...sx }}>
      <FlexBox justifyContent={'space-between'} alignItems={'center'} gap={1} sx={{ flexWrap: 'wrap' }}>
        <ConditionContainer
          active={!isLoading}
          alternative={<Skeleton variant='text' sx={{ fontSize: '1rem', width: '60%', maxWidth: '300px' }} />}
        >
          <Box>
            <FlexBox alignItems='center' gap={1} flexWrap='wrap'>
              <Typography variant={'h1'}>{title}</Typography>
              {badge}
            </FlexBox>
            {<SubtitleEval subtitle={subtitle} />}
          </Box>
        </ConditionContainer>
        {children}
        {hasFilter && <FilterList />}
      </FlexBox>
    </Paper>
  );
};

export default memo(PageHeader);
